export const PopupsSymbol = Symbol('Popups')
export const PopupUtilsSymbol = Symbol('PopupUtils')
export const PopupsLinkUtilsAPISymbol = Symbol('PopupsLinkUtilsAPI')
export const PopupsAPISym = Symbol('PopupsAPISym')

export const name = 'popups' as const
